import styled from "styled-components";

export const Input = styled.input`
  background: #ffffff;
  border: 1px solid #d1d1d1;
  border-radius: 9px;
  font-family: "Inter";
  font-style: normal;
  padding: 0.75em;
  font-weight: 400;
  font-size: 1em;
  width: ${(props) => props.width};
  line-height: 18px;
  margin: 0.625em 0;
  display: flex;
  height: 2.5em;
  width: 19.6em;
  color: #4a4a4a;

  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 0.625em auto;
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.mobile.sm}) {
  }
`;
export const MainSection = styled.div`
  padding: 3.75em 10%;
  display: flex;
  justify-content: center;
  height: 85vh;
  margin-left: 4%;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-left: 0;
    display: block;
    height: auto;
    margin-top: -50px;
    padding-top: 0;
  }
`;
export const RecoverSection = styled.div`
  flex: 1;
  padding-left: 20%;
  margin-top: 5em;

  h2 {
    font-size: 29px;
    font-weight: 700;
  }
  .bold {
    font-weight: 700;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    padding-left: 0;
    /* width: 50%; */
  }
`;
export const ImageSection = styled.div`
  width: 356px;
  height: 356px;
  margin: 0px auto;
  margin-bottom: 13%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`;
